module.exports = __webpack_public_path__ + "static/media/DBHeaventNow-Bold.8d5dbecf.woff2";